import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Placeholder Testimonials component (replace with actual Testimonials component)
const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: 'Elias Mureithi',
      quote: 'TGL Credit Limited provided fast and reliable financing for my business. Their team was professional and supportive throughout.',
      role: 'Entrepreneur',
      image: '/assets/images/testimonials/elias.jpg',
    },
    {
      id: 2,
      name: 'Everline Odoyo',
      quote: 'The logbook loan process was seamless, and the terms were clear. I highly recommend TGL for their transparency.',
      role: 'Small Business Owner',
      image: '/assets/images/testimonials/everline.jpg',
    },
    {
      id: 3,
      name: 'Shammah Bushuru',
      quote: 'TGL’s medical insurance gave my family peace of mind. Their customer service is top-notch!',
      role: 'Family Provider',
      image: '/assets/images/testimonials/shammah.jpg',
    },
    {
      id: 4,
      name: 'Mbitu James',
      quote: 'TGL’s asset financing helped me expand my fleet with ease. Their flexible terms made all the difference.',
      role: 'Transport Business Owner',
      image: '/assets/images/testimonials/mbitu.jpg',
    },
    {
      id: 5,
      name: 'Emmanuel Kirya',
      quote: 'With TGL’s support, I secured a loan that transformed my startup. Their team truly cares about client success.',
      role: 'Tech Entrepreneur',
      image: '/assets/images/testimonials/emmanuel.jpg',
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
      {testimonials.map((testimonial, index) => (
        <div
          key={testimonial.id}
          className="relative bg-white rounded-lg shadow-md hover:shadow-lg border border-maasai-blue/10 transition-all duration-300 hover:-translate-y-1 hover:scale-105 animate-fade-up group"
          style={{ animationDelay: `${0.6 + index * 0.2}s`, willChange: 'transform, box-shadow' }}
        >
          <div className="p-6">
            <img
              src={testimonial.image}
              alt={testimonial.name}
              className="w-16 h-16 rounded-full mx-auto mb-4 object-cover border border-maasai-blue/20 group-hover:border-maasai-red/20 transition-all duration-300"
              loading="lazy"
              onError={(e) => {
                e.target.src = '/assets/images/fallback.jpg' || 'https://via.placeholder.com/150';
                console.error(`Failed to load image: ${testimonial.image}`);
              }}
            />
            <p className="text-base font-inter font-medium text-gray-600 mb-4 text-center">{testimonial.quote}</p>
            <h3 className="text-lg font-inter font-bold text-maasai-blue text-center mb-1 tracking-tight">{testimonial.name}</h3>
            <p className="text-sm font-inter font-medium text-gray-500 text-center">{testimonial.role}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

function TestimonialsPage() {
  const headerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        const scrollY = window.scrollY;
        headerRef.current.style.transform = `translateY(${scrollY * 0.2}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-gradient-to-b from-gray-50 to-white py-24 sm:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-24 max-w-6xl">
        <div
          className="relative bg-white/95 backdrop-blur-md rounded-lg py-16 px-10 text-center mb-20 shadow-lg overflow-hidden"
          ref={headerRef}
          style={{ willChange: 'transform' }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-maasai-blue/5 to-maasai-red/5 z-0" />
          <h1 className="relative text-3xl sm:text-4xl lg:text-5xl font-inter font-extrabold tracking-tight text-maasai-blue z-10">
            <span className="group inline-block relative">
              What Our
              <span className="absolute bottom-0 left-0 w-full h-1 bg-maasai-red transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300" />
            </span>{' '}
            <span className="text-gray-800">Clients Say</span>
          </h1>
          <p className="relative text-base sm:text-lg font-inter font-medium text-gray-600 mt-4 max-w-3xl mx-auto animate-fade-up z-10" style={{ animationDelay: '0.2s' }}>
            Discover how TGL Credit Limited empowers clients with trusted, tailored financial solutions delivered with excellence.
          </p>
        </div>
        <Testimonials />
        <div className="text-center mt-20 animate-fade-up" style={{ animationDelay: '0.4s' }}>
          <Link
            to="/contact-apply"
            className="inline-flex items-center bg-gradient-to-r from-maasai-blue to-maasai-red text-white font-inter font-semibold px-10 py-5 rounded-md hover:bg-maasai-orange hover:text-maasai-blue hover:shadow-lg hover:shadow-maasai-red/30 transition-all duration-300 uppercase tracking-widest text-base focus:ring-2 focus:ring-maasai-blue focus:ring-offset-2 group"
            style={{ willChange: 'transform, box-shadow' }}
            aria-label="Contact TGL Credit Limited"
          >
            Contact Us
            <svg
              className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform duration-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
        </div>
      </div>
      <style>
        {`
          @keyframes fade-up {
            from { opacity: 0; transform: translateY(15px); }
            to { opacity: 1; transform: translateY(0); }
          }
          .animate-fade-up {
            animation: fade-up 0.8s ease-in-out forwards;
            will-change: transform, opacity;
          }
          .backdrop-blur-md {
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
            background-color: rgba(255, 255, 255, 0.95);
          }
          @media (prefers-reduced-motion: reduce) {
            .animate-fade-up, .hover\\:scale-105, .hover\\:shadow-lg, .group-hover\\:translate-x-1, .group-hover\\:scale-x-100, .group-hover\\:border-maasai-red\\/20 {
              animation: none !important;
              transform: none !important;
              transition: none !important;
            }
          }
        `}
      </style>
    </div>
  );
}

export default TestimonialsPage;